
import { Skeleton } from "@/components/ui/skeleton";

export function BookSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="w-full h-[240px] md:h-[280px] rounded-[20px]" />
      <div className="px-1 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <div className="flex gap-2">
          <Skeleton className="h-3 w-10 rounded-full" />
          <Skeleton className="h-3 w-10 rounded-full" />
        </div>
      </div>
    </div>
  );
}
